/**
 * Discord domain — bot config, voice connection state, slash commands.
 */
import { z } from "zod";
export const SetAllowedChannelBodySchema = z.object({
    channelId: z.string().min(1),
});
export const JoinVoiceBodySchema = z.object({
    channelId: z.string().min(1),
    guildId: z.string().min(1),
    /** Client's current track — starts voice playback immediately after join. */
    trackId: z.number().int().positive().optional(),
});
export const VoiceResumeBodySchema = z.object({
    trackId: z.number().int().positive().optional(),
});
export const SetVoiceVolumeBodySchema = z.object({
    volume: z.number().min(0).max(1),
    /** When set, toggles per-track loudness correction in voice ffmpeg. */
    normalize: z.boolean().optional(),
});
export const VoiceSeekBodySchema = z.object({
    seconds: z.number().nonnegative(),
});
//# sourceMappingURL=discord.js.map